const translations = {
    aam: 'Application Maps',
    account: 'My Account',
    copyright: 'Copyright © {{year}} by AcreConnect',
    createProductUsageReport: 'Create New Report',
    createWorkOrder: 'Create New Work Order',
    customers: 'Customers',
    dashboard: 'Dashboard',
    faaReports: 'FAA Reports',
    flightLog: 'Flights & Maps',
    flyForRantizo: 'Fly for Rantizo',
    logout: 'Log Out',
    manageConnections: 'Manage Connections',
    manageEquipment: 'Manage Equipment',
    manageOrganization: 'Manage Organization',
    myOrganization: 'My Organization',
    productUsageReports: 'Product Usage Reports',
    rantizoShop: 'Rantizo Shop',
    serviceOperatorMap: 'Service Provider Map',
    termsOfService: 'Privacy Policy and Terms of Service',
    workOrders: 'Work Orders'
};

export default translations;
